module.exports = __webpack_public_path__ + "assets/img/0e182161ee99b3f693e0560537a5e7c0.png";